import React, { useContext } from "react";
import { Button, Modal, Tag } from "antd";
import { BarcodeOutlined } from "@ant-design/icons";
import { IAppUserAuto, IGiveawayAutoWithDetails } from "../../../../../interfaces";
import Loading from "../../../../../components/Loading";
import TicketsAutoList from "../../../../../components/TicketsAutoList ";
import { ThemeContext } from "../../../../../contexts/ThemeContext";
import useModalGiveawayTicketsAuto from "./useModalGiveawayTicketsAuto";

interface IProps {
    open: boolean;
    onClose: () => void;
    giveaway?: IGiveawayAutoWithDetails | null;
    appUserAuto?: IAppUserAuto;
}

export default function ModalGiveawayTicketsAuto({
    open,
    onClose,
    giveaway,
    appUserAuto,
}: IProps) {
    const { theme } = useContext<any>(ThemeContext);
    const isDark = theme === "dark";

    const { tickets, isLoading } = useModalGiveawayTicketsAuto({
        id: appUserAuto?.id,
        giveawayId: giveaway?.id,
    });

    return (
        <Modal
            width={950}
            open={open}
            title={
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginRight: 24 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <div
                            style={{
                                width: 34,
                                height: 34,
                                borderRadius: 8,
                                background: isDark ? "rgba(114, 46, 209, 0.2)" : "#f9f0ff",
                                border: `1px solid ${isDark ? "rgba(114, 46, 209, 0.4)" : "#d3adf7"}`,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <BarcodeOutlined style={{ color: "#722ed1", fontSize: 18 }} />
                        </div>
                        <div>
                            <div style={{ fontSize: 15, fontWeight: 700, color: isDark ? "#f0f0f0" : "#1e293b", lineHeight: 1.2 }}>
                                Bilhetes do Sorteio
                            </div>
                            <div style={{ fontSize: 12, color: isDark ? "#8c8c8c" : "#64748b", fontWeight: 400 }}>
                                {giveaway?.description || "Visualização de bilhetes participantes"}
                            </div>
                        </div>
                    </div>
                    {tickets.length > 0 && (
                        <Tag
                            color="purple"
                            style={{
                                borderRadius: 8,
                                padding: "3px 10px",
                                fontWeight: 600,
                                fontSize: 12.5,
                            }}
                        >
                            {tickets.length.toLocaleString("pt-BR")} bilhetes
                        </Tag>
                    )}
                </div>
            }
            footer={[
                <Button key="close" type="primary" onClick={onClose}>
                    Fechar
                </Button>,
            ]}
            onCancel={onClose}
            destroyOnClose
            centered
        >
            <Loading loading={isLoading}>
                <div style={{ maxHeight: "65vh", overflowY: "auto", overflowX: "hidden", padding: "10px 4px 4px 4px" }}>
                    <TicketsAutoList
                        paginated={false}
                        title={appUserAuto?.name}
                        tickets={tickets}
                        isLoading={isLoading}
                        giveawayId={giveaway?.id}
                        totalTickets={tickets.length}
                        emptyListMessage="Usuário não possui bilhetes concorrendo neste sorteio"
                    />
                </div>
            </Loading>
        </Modal>
    );
}
